import React from 'react';
import { AgentThreadList } from '@/experiences/sales-portal/domain/superintelligence/components/agent-thread-list';
import { createStyles } from '@/contexts/theme-context';
import { ScrollView, View } from 'react-native';

const SIDEBAR_WIDTH = 280;

export const AgentThreadSidebar: React.FC = () => {
  const [styles] = useStyles();

  return (
    <View style={styles.sidebar}>
      <ScrollView style={styles.list}>
        <AgentThreadList />
      </ScrollView>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  list: {
    flex: 1,
  },
  sidebar: {
    borderRightColor: theme.sk.color.border.primary,
    borderRightWidth: 1,
    marginRight: theme.sk.spacing.spaceMedium,
    paddingLeft: theme.sk.spacing.spaceMedium,
    paddingRight: theme.sk.spacing.spaceMedium,
    width: SIDEBAR_WIDTH,
  },
}));
